/**
 * Procedure Categories and Procedures for Diploma in DVL (Dermatology, Venereology & Leprosy) students
 * Extracted with strict evidence from official NMC PDF
 */
export const DVL_PROCEDURES = {
  "Dermatosurgery & Surgical Procedures": [
    "Skin Biopsy",
    "Incisions, Stitching and Suturing",
    "Chemical Peels",
    "Manual Dermabrasion",
    "Cryosurgery / Cryotherapy",
    "Nail Surgery",
    "Chemical Cauterization",
    "Wound Dressing",
  ],
  "Diagnostic & Cutaneous Laboratory Procedures": [
    "Potassium Hydroxide (KOH) Mount",
    "Gram Stain",
    "Giemsa Stain",
    "Acid-Fast Bacilli (AFB) Stain / AFB Smear",
    "Slit Skin Smears",
    "Tissue Smears",
    "Wood's Lamp Examination",
    "Patch Testing & Photopatch Testing",
  ],
  "Venereology Interventions": [
    "Dark Ground Illumination (Dark Field Microscopy)",
    "Bubo Aspiration",
  ],
};

export const DVL_CATEGORIES = Object.keys(DVL_PROCEDURES);

export const isDiplomaInDVLDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (d.includes("dvl") ||
    d.includes("dermatology") ||
    (d.includes("diploma") && d.includes("dermatology"))) &&
    !(d.includes("md") || d.includes("master of medicine"))
  );
};
